var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4,7h5c0,0,0.1,0,0.1,0c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3c0,0,0.1,0,0.1,0h11c0.6,0,1-0.4,1-1s-0.4-1-1-1H17 c0,0-0.1,0-0.1,0c-0.4-1.7-2-3-3.9-3S9.6,3.3,9.1,5C9.1,5,9,5,9,5H4C3.4,5,3,5.4,3,6S3.4,7,4,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,15h-4c0,0-0.1,0-0.1,0c-0.4-1.7-2-3-3.9-3s-3.4,1.3-3.9,3c0,0-0.1,0-0.1,0H4c-0.6,0-1,0.4-1,1s0.4,1,1,1h12 c0,0,0.1,0,0.1,0c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3c0,0,0.1,0,0.1,0h4c0.6,0,1-0.4,1-1S28.6,15,28,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,25H17c0,0-0.1,0-0.1,0c-0.4-1.7-2-3-3.9-3s-3.4,1.3-3.9,3c0,0-0.1,0-0.1,0H4c-0.6,0-1,0.4-1,1s0.4,1,1,1h5 c0,0,0.1,0,0.1,0c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3c0,0,0.1,0,0.1,0h11c0.6,0,1-0.4,1-1S28.6,25,28,25z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilter);
export default __webpack_public_path__ + "static/media/ic_filter.5c6739fa94fa47432ab1248c060d5578.svg";
export { ForwardRef as ReactComponent };